import React from "react";

const PILL: Record<string, string> = {
  ongoing: "bg-[#cfe0ff] text-[#0b1220]",
  active: "bg-[#cfe0ff] text-[#0b1220]",
  completed: "bg-emerald-200 text-emerald-900",
  cancelled: "bg-rose-200 text-rose-900",
  issue: "bg-amber-200 text-amber-900",
};

export default function TripCards({
  list,
  highlightId,
  onSelect,
}: {
  list: [string, any][];
  highlightId?: string;
  onSelect?: (id?: string) => void;
}) {
  return (
    <div className="grid gap-3 [grid-template-columns:repeat(auto-fill,minmax(280px,1fr))]">
      {list.map(([id, t]) => {
        const status = (t.status || "ongoing").toString().toLowerCase();
        const isHit =
          Boolean(highlightId) &&
          (String(id) === String(highlightId) ||
            String(t?.vehicleId) === String(highlightId));

        const distance =
          typeof t.distanceKm === "number"
            ? `${t.distanceKm.toFixed(1)} km`
            : "—";
        const totalDistance =
          typeof t.totalDistanceKm === "number"
            ? `${t.totalDistanceKm.toFixed(1)} km`
            : "—";
        const speed =
          typeof t.speedKph === "number" ? `${t.speedKph} km/h` : "—";
        const battery =
          typeof t.batteryPct === "number" ? `${t.batteryPct}%` : "—";
        const fuel =
          typeof t.fuel === "number" ? `${Math.round(t.fuel)}%` : "—";
        const pct = Math.max(0, Math.min(100, Math.round(t.progress ?? 0)));

        return (
  //         <div
  //           id={`trip-${id}`}
  //           key={id}
  //           className={`rounded-xl p-3 bg-[#bfd4fe] border border-[#93bafd] text-[#0b1220] shadow-sm transition
  // ${isHit ? "bg-white/60 border-blue-500/60" : "hover:bg-white/40"}`}
  //         >
  <div
            onClick={() => onSelect?.(id)}
            id={`trip-${id}`}
            key={id}
            className={`rounded-xl cursor-pointer select-none p-3 bg-[#bfd4fe] border border-[#93bafd] text-[#0b1220] shadow-sm 
            transition ${isHit ? "outline outline-2 outline-blue-500 shadow-[0_0_8px_rgba(59,111,246,0.4)]" : "hover:bg-white/70"}`}
          >
            {/* tripId (wrap if long) */}
            <div className="mb-2">
              <div className="text-sm font-medium break-words max-w-full">
                {id}
              </div>
            </div>

            {/* vehicleId */}
            <div className="mb-2 text-sm">
              <span className="font-semibold">Vehicle ID: </span>
              <span className="text-sm">{t.vehicleId ?? "—"}</span>
            </div>

            {/* status */}
            <div className="mb-2">
              <span
                className={`px-2 py-0.5 rounded-full text-[12px] font-semibold inline-flex ${
                  PILL[status] || "bg-slate-200 text-slate-900"
                }`}
              >
                {status.toUpperCase()}
              </span>
            </div>

            {/* progress */}
            <div className="mb-2">
              <div className="w-[50%] h-2 bg-white/70 rounded-full overflow-hidden">
                <div
                  className={`${
                    pct >= 100 ? "bg-emerald-400" : "bg-[#3b6ef6]"
                  } h-full`}
                  style={{ width: `${pct}%` }}
                />
              </div>
              <div className="text-xs text-slate-700 mt-1">{pct}% Progress</div>
            </div>

            {/* distance travelled */}
            <div className="mb-1 text-sm">
              <span className="font-semibold">Distance travelled: </span>
              <span>{distance}</span>
            </div>

            {/* total distance */}
            <div className="mb-1 text-sm">
              <span className="font-semibold">Total distance: </span>
              <span>{totalDistance}</span>
            </div>

            {/* speed */}
            <div className="mb-1 text-sm">
              <span className="font-semibold">Speed: </span>
              <span>{speed}</span>
            </div>

            {/* battery */}
            <div className="mb-1 text-sm">
              <span className="font-semibold">Battery: </span>
              <span>{battery}</span>
            </div>

            {/* fuel */}
            <div className="text-sm">
              <span className="font-semibold">Fuel: </span>
              <span>{fuel}</span>
            </div>
          </div>
        );
      })}
    </div>
  );
}
